export enum TeamAlt {
    TEAM,
    TEAM_AND_SUBORDINATES,
}
